module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/hairmake_sns_02-bd779bf4862b558ee52dfa8c193424d8.jpg";